import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'ol/ol.css';
import './geocoding.css';
import apply from 'ol-mapbox-style';
import { LineString, Polygon, Circle } from 'ol/geom';
import Map from 'ol/Map';
import View from 'ol/View';
import Hash from './hash';
import GeoJSON from 'ol/format/GeoJSON';
import WKT from 'ol/format/WKT';
import { geocodingSearch, geocodingReverse, geocodingSimilar } from './geocoding';
import { transform } from 'ol/proj';

import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { DragBox, Draw } from 'ol/interaction';
import Feature from 'ol/Feature';
import proj4 from 'proj4';
import { register } from 'ol/proj/proj4';
import { fromLonLat, get as projGet } from 'ol/proj'

import { clear, div, htmlEl, table, loc, badge } from './ui';
import { webLang, normalizedLang, texts, applyLocale, getLocalizationGroup } from './locale';
import { fetchCollections } from "./api";
import TileGrid from 'ol/tilegrid/TileGrid';
import vectorlayers from './vectorlayers';
import { getArea, getLength } from 'ol/sphere'

//import featuresStyle from './data/style.json';
import featuresStyle from './data/style-kiinteisto-avoin-vektoritiilet.json';


proj4.defs("EPSG:3857","+proj=merc +a=6378137 +b=6378137 +lat_ts=0 +lon_0=0 +x_0=0 +y_0=0 +k=1 +units=m +nadgrids=@null +wktext +no_defs +type=crs");
proj4.defs("EPSG:4326", "+proj=longlat +datum=WGS84 +no_defs");
proj4.defs("EPSG:3067", "+proj=utm +zone=35 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");
register(proj4);


const defaultProps = ['label', 'source', 'label:municipality'];

const params = (new URL(document.location)).searchParams,
  lang = normalizedLang[params.get('lang')] || 'fin',
  radius = Number(params.get('radius')) || 500,
  sources = params.get('sources'),
  apiSelection = params.get('api') || 'tuotanto:geoportal';

document.lang = webLang[lang];
const locale = texts[lang];

const dontDeclutter = params.get('declutter') != undefined && params.get('declutter') === 'false'

const mapOpts = {
  dataProj: 'EPSG:4326',
  viewProj: 'EPSG:3857',
  dataCrs: null,//'http://www.opengis.net/def/crs/EPSG/0/4326',
  tileGridSet: 'WGS84_Pseudo-Mercator',
  featuresMinZoom: 11,
  styleFuncOptions: {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128, 64, 32, 16, 8, 4, 2, 1, 0.5, 0.25, 0.125]
  },
  projection: projGet('EPSG:3857'),
  //extent: [-548576, 6291456, 1548576, 8388608],
  adjustZ: 3
};


//mapOpts.projection.setExtent(mapOpts.extent);





const wkt = new WKT();

const
  apiKey = '7cd2ddae-9f2e-481c-99d0-404e7bc7a0b2',
  apiVer = 'v2',
  apiVerUrls = {
    'tuotanto:pelias': `https://avoin-paikkatieto.maanmittauslaitos.fi/geocoding/${apiVer}/pelias`,
    'tuotanto:geoportal': `https://avoin-paikkatieto.maanmittauslaitos.fi/geocoding/${apiVer}/geoportal`,
    'tuotanto:asiointi': `https://avoin-paikkatieto.maanmittauslaitos.fi/geocoding/${apiVer}/asiointi`,
    'qa:pelias': `https://avoin-visukuva.nls.fi/geocoding/${apiVer}/pelias`,
    'qa:geoportal': `https://avoin-visukuva.nls.fi/geocoding/${apiVer}/geoportal`,
    'qa:asiointi': `https://avoin-visukuva.nls.fi/geocoding/${apiVer}/asiointi`

  };

const limit = 200,
  buffer = 100;

let colls = [],
  collsByFeatTypeMap = {};


let currentSelection = {
  geom: undefined
};

let state = 'navigation_p1';

var mapSelectionSource = new VectorSource({});
let selTools = {
  pt: undefined,
};

let format = new GeoJSON({
  featureProjection: mapOpts.viewProj,
  dataProjection: mapOpts.dataProj
})


function cancelSelTools() {
  for (const [key, value] of Object.entries(selTools)) {
    value.setActive(false);
  }
}

window.addEventListener("load", (event) => {

  applyLocale(locale);

  let center = [476143, 6945745];

  const hash = new Hash(),
    map = new Map({
      target: 'map'
        });
  hash.addTo(map);

  window.map = map;

  applyOptionsToStyle({ '[AVOIN-NLS-API-KEY]': apiKey, '[TILEMATRIXSET]': mapOpts.tileGridSet }, featuresStyle);
  applyApiSelection(apiSelection);

  apply(map, featuresStyle).then(function (map) {
  return map;
}).then((map) => {

    applyMoveEnd(map);
    applySelDraw(map, 'Point', 'pt');
    applyBgSelections(map);
    applyButtons(map);
    applySearch(map);
    applyState('navigation_p1');
    map.addLayer(new VectorLayer({
      style: {
        'fill-color': ['string', ['get', 'COLOR'], 'rgba(0,0,255,0.1'],
        'stroke-color': ['string', ['get', 'COLOR'], 'rgba(0,0,255,1)']
      },
      source: mapSelectionSource
    }));


  });
});



function applyBgSelections(map) {
  const bgSelEl = document.getElementById('bgSelections');

  const bgs = ['rasteritaustakartta', 'kiinteisto-avoin'],
    bglocales = getLocalizationGroup(locale, 'bg');

  bgs.forEach(bg => {

    const divEl = div(bgSelEl),
      inputEl = htmlEl(divEl, 'input', 'form-check-input'),
      labelEl = htmlEl(divEl, 'label', 'form-check-label');

    divEl.classList.add('form-check');
    divEl.classList.add('form-switch');
    inputEl.setAttribute('id', bg);
    inputEl.setAttribute('type', 'checkbox');
    inputEl.setAttribute('data-bg', bg);
    inputEl.setAttribute('checked', 'checked');
    labelEl.setAttribute('for', bg);
    labelEl.innerText = bglocales[bg] || '?';

    inputEl.onchange = (evt) => {
      const evtTgtEl = evt.target,
        evtTgtBg = evtTgtEl.dataset.bg,
        evtTgtBgSel = evtTgtEl.checked;

      applyBgSelectionToMap(map, evtTgtBg, evtTgtBgSel);
    };
  });


}


function applyButtons(map) {
  const ptbutton = document.getElementById('pt');
  ptbutton.onclick = () => {
    mapSelectionSource.clear();
    const el = document.getElementById('info');
    clear(el);

    cancelSelTools();
    selTools.pt.setActive(true);
    applyState('selection_pt');
  }

  const cancelbutton = document.getElementById('cancel');
  cancelbutton.onclick = () => {
    const el = document.getElementById('info');
    clear(el);
    cancelSelTools();
    applyState('navigation_p1');
    clearFeatures(map);
  }



}



function applySelDraw(map, geomType, selId) {
  let draw = new Draw({
    source: mapSelectionSource,
    type: geomType,
  });
  selTools[selId] = draw;
  draw.setActive(false);

  draw.on('drawend', function (e) {

    const geometry = e.feature.getGeometry().clone();


    featuresFromGeometry(map, geometry, true);


    // hmm. setActive false tuo default dblclikc
    // hmm2 applyState tuo ilmeisesi layout muutoksen ja eventtejä
    window.setTimeout(() => {
      draw.setActive(false);
      //applyState('navigation_p2');

    }, 1000);
  });


  map.addInteraction(draw);




}

function applyBgSelectionToMap(map, bg, bgSel) {
  const layers = map.getLayers().getArray();
  console.log(map, layers, bg);
  layers.filter(l => l.get('mapbox-source') == bg || l.getSource().get('mapbox-source') == bg).forEach(l => l.setVisible(bgSel));
}

function getFeatureLayerSourceFromMap(map) {
  const layer = map.getLayers().getArray().find(layer => layer.get('mapbox-source') == 'kipa'),
    source = layer.getSource();
  return source;
}

function applySearch(map) {

  let textEl = document.getElementById('text');
  textEl.addEventListener("keyup", (evt) => {
    if (evt.code === 'Enter') {
      featuresFromText(map, textEl.value, true);
    }
  });
  let searchEl = document.getElementById('search');
  searchEl.onclick = () => {
    featuresFromText(map, textEl.value, true)
  };

  let similarEl = document.getElementById('similar');
  similarEl.addEventListener('change', (e) => {
    console.log("SIMILAR SELECTED ", similarEl);
    let similarSelected = similarEl.options[similarEl.selectedIndex];
    textEl.value = similarSelected.value;
    featuresFromText(map, textEl.value, true);

  });
}

function featuresFromText(map, text, infos) {
  mapSelectionSource.clear();

  const infoEl = document.getElementById('info');
  clear(infoEl);

  var apiUrl = getApiURL(),
    apiSimilarUrl = `${apiUrl.substring(0, apiUrl.lastIndexOf('/'))}/searchterm`;

  const similarEl = document.getElementById('similar');
  clear(similarEl);

  geocodingSimilar((fc) => {
    console.log("SIMILAR", fc);

    let opts = fc.terms.map(f => {
      var opt = document.createElement('option')
      opt.value = f.text;
      opt.text = f.text;
      return opt;
    });

    opts.forEach(opt => similarEl.add(opt));

  }, apiSimilarUrl, {
    'text': text,
    'size': 20,
    'crs': mapOpts.dataCrs,
    'request-crs': mapOpts.dataCrs,
    'api-key': apiKey,
    'lang': lang,
    'sources': sources
  });

  geocodingSearch((fc) => {
    const feats = format.readFeatures(fc),
      searchSources = fc.geocoding.query.sources,
      matchedParts = fc.geocoding.metadata[0] ? fc.geocoding.metadata[0].matchingCodelists : {};

    if (infos) {
      addFeaturesProperties(map, infoEl, feats, defaultProps, searchSources, matchedParts,
        (evt) => {
          const evtTgtEl = evt.target,
            evtTgtWKTGeom = evtTgtEl.dataset.geom,
            evtGeom = wkt.readGeometry(evtTgtWKTGeom);

          const evtFeat = new Feature({
            COLOR: 'magenta',
            geometry: new Circle(evtGeom.getFirstCoordinate(), 10)
          });
          //mapSelectionSource.clear();
          mapSelectionSource.addFeature(evtFeat);

          map.getView().fit(evtGeom, { padding: [170, 50, 30, 150], minResolution: 2 });

        }
      );
    }
    return true;


  }, apiUrl, {
    'text': text,
    'size': limit,
    'crs': mapOpts.dataCrs,
    'request-crs': mapOpts.dataCrs,
    'api-key': apiKey,
    'lang': lang,
    'sources': sources
  })
}


function featuresFromGeometry(map, geom, infos) {
  currentSelection.geom = geom;

  
  
  const dataGeom = geom.clone().transform(map.getView().getProjection(),mapOpts.dataProj);

  mapSelectionSource.clear();
//  mapSelectionSource.addFeature(feat);

  const infoEl = document.getElementById('info');
  clear(infoEl);
  applyState('navigation_p2');
  geocodingReverse((fc) => {
    const feats = format.readFeatures(fc),
      searchGeom = format.readGeometry(fc.geocoding.query.searchGeometry),
      searchSources = fc.geocoding.query.sources,
      matchedParts = fc.geocoding.metadata[0] ? fc.geocoding.metadata[0].matchingCodelists : {};


    const searchFeat = new Feature({
      geometry: searchGeom
    })
    mapSelectionSource.addFeature(searchFeat);

    if (infos) {
      addFeaturesProperties(map, infoEl, feats, defaultProps, searchSources, matchedParts,
        (evt) => {
          const evtTgtEl = evt.target,
            evtTgtWKTGeom = evtTgtEl.dataset.geom,
            evtGeom = wkt.readGeometry(evtTgtWKTGeom);

          const evtFeat = new Feature({
            COLOR: 'magenta',
            geometry: new Circle(evtGeom.getFirstCoordinate(), 10)
          });
          //mapSelectionSource.clear();
          mapSelectionSource.addFeature(evtFeat);

          map.getView().fit(evtGeom, { padding: [170, 50, 30, 150], minResolution: 2 });

        }
      );
    }
    return true;
  }, getApiURL(),  {
    'geom': dataGeom,
    'size': limit,
    'crs': mapOpts.dataCrs,
    'request-crs': mapOpts.dataCrs,
    'api-key': apiKey,
    'lang': lang,
    'radius': radius,
    'sources': sources
  });

}

function getApiURL() {
  let el = document.getElementById('api'),
    selIndex = api.selectedIndex,
    opt = el.options[selIndex],
    apiId = opt.value;

  return apiVerUrls[apiId];

}


function addFeaturesProperties(map, parentEl, feats, propList, sources, matchedParts, clickFunc) {
  const propMap = Object.assign(...propList.map(key => ({ [key]: true })));
  const tblEl = htmlEl(parentEl, 'table', 'table'),
    tblHeadEl = htmlEl(tblEl, 'thead'),
    tblBodyEl = htmlEl(tblEl, 'tbody');

  const tblSourceEl = htmlEl(tblBodyEl, 'tr');
  let tblSourceValueEl = htmlEl(tblSourceEl, 'td');
  tblSourceValueEl.setAttribute('colspan', 4);
  tblSourceValueEl.innerText = '' + sources;

  const tblMatchEl = htmlEl(tblBodyEl, 'tr');
  let tblMatchValueEl = htmlEl(tblMatchEl, 'td');
  tblMatchValueEl.setAttribute('colspan', 4);
  for (const [matchGroupKey, matchGroupValue] of Object.entries(matchedParts)) {
    for (const [matchKey, matchValue] of Object.entries(matchGroupValue)) {
      let badgeEl = badge(`${matchValue.label} (${matchValue.value})`);
      tblMatchValueEl.appendChild(badgeEl);
    }
  }



  feats.forEach(f => {
    const s_geom_wkt = wkt.writeGeometry(f.getGeometry());
    const rawJson = { ...f.getProperties() };

    const json = Object.fromEntries(Object.entries(rawJson).filter(([k, v]) => propMap[k]));

    json.geometry = null;
    //    info(el, json);
    let title = '';
    if (json['featureType']) {
      title = `${json['featureType']} (OGC API Features)`;
    } else if (json['layer']) {
      title = `${json['layer']} (Vector Tile)`;
      delete json.layer;
    }

    const tblRowEl = htmlEl(tblBodyEl, 'tr'),
      tblHeaderEl = htmlEl(tblRowEl, 'td');

    propList.forEach(p => {
      let tblValueEl = htmlEl(tblRowEl, 'td');
      tblValueEl.innerText = '' + json[p];
    });

    tblHeaderEl.setAttribute('scope', 'row');
    let locEl = loc();
    tblHeaderEl.appendChild(locEl);

    locEl.setAttribute('data-geom', s_geom_wkt);
    tblHeaderEl.setAttribute('data-geom', s_geom_wkt);
    tblHeaderEl.onclick = clickFunc;
  });
}


function clearFeatures(map) {
  const
    view = map.getView(),
    source = getFeatureLayerSourceFromMap(map);

  currentSelection.geom = undefined;

  mapSelectionSource.clear();
  source.clear();
  clear(document.getElementById('info'));

  let searchEl = document.getElementById('text');
  searchEl.value = '';

  let similarEl = document.getElementById('similar');
  clear(similarEl);


}


function applyMoveEnd(map) {
  map.on("moveend", (evt) => {
    applyState('navigation_p1');


  });

}






function applyState(s) {

  state = s;
  const el = document.getElementById('state');

  el.innerText = locale.state[state];


}

function applyOptionsToStyle(opts, style) {
  if (!opts) {
    return;
  }
  for (const [optKey, optValue] of Object.entries(opts)) {
    if (style.glyphs) {
      style.glyphs = style.glyphs.replaceAll(optKey, optValue);
    }
    if (style.sources) {
      for (const [key, value] of Object.entries(style.sources)) {
        if (value.tiles) {
          value.tiles = value.tiles.map(u => u.replaceAll(optKey, optValue));
        }
        if (value.url) {
          value.url = value.url.replaceAll(optKey, optValue);
        }
      }
    }
  }
}

function geomViewToData(geom) {
  if (mapOpts.viewProj == mapOpts.dataProj) {
    return geom;
  }
  return geom.transform(mapOpts.viewProj, mapOpts.dataProj);
}
function geomDataToView() {
  if (mapOpts.viewProj == mapOpts.dataProj) {
    return geom;
  }
  return geom.transform(mapOpts.dataProj, mapOpts.viewProj);

}

function coordDataToView(coord) {
  if (mapOpts.viewProj == mapOpts.dataProj) {
    return coord;
  }

  transform(coord, mapOpts.dataProj, mapOpts.viewProj);
}
function coordViewToData(coord) {
  if (mapOpts.viewProj == mapOpts.dataProj) {
    return coord;
  }
  return transform(coord, mapOpts.viewProj, mapOpts.dataProj);

}


function validateSelection(geom) {

  if (geom instanceof Polygon) {

    let area = getArea(geom, { projection: mapOpts.projection });
    console.log("AREA", area);
    return area < 9999999.999999999;

  } else if (geom instanceof LineString) {
    let length = getLength(geom, { projection: mapOpts.projection });
    console.log("LENGTH", length);
    return length < 10000.0;
  }

  return true;
}

function applyApiSelection(apiSel) {

  let apiEl = document.getElementById('api'),
    apiOpts = [...apiEl.children];

  apiOpts.forEach(el => {
    el.selected = el.value === apiSel;
  });

}